export default {
    saveStoreInfo: function ({ commit }, payload) {
        commit('saveStoreInfo', payload);
    },
    changQeryParams: function ({ commit }, payload) {
        commit('initQueryParams', payload);
    },

}
